import { injectable } from 'inversify';
import { Vue } from 'vue-property-decorator';
import { queryElements, replaceWithElement } from '@/app/shared/utils/content-utils';
import * as Api from "@/app/interaction/api";
import { createInteractionComponent } from '@/app/interaction/ui'
import { AccordionItem, AccordionContent,
         AccordionState } from './accordion-interfaces';

@injectable()
export class IncludeAccordionHandler implements Api.IncludeComponentsHandlerInterface {

  public async includeComponents($parsedContent: any): Promise<Vue[]> {
  const elements: any = queryElements('.accordion.component', $parsedContent);
    if (elements === null) {
      return [];
    }

    let components: Vue[] = []
    for (const element of elements) {
      const $element: any = $(element);
      const component = this.includeComponent($element);
      components.push(component)
    }

    return components
  }

  private includeComponent($element: any): Vue {
    const id: string = $element.attr('id');
    const title: string|null = $('.accordion__title', $element).text() || null;
    const instruction: string|null = $('.accordion__instruction', $element).html() || null;
    const items: AccordionItem[] = this.getItems($('.accordion__item', $element));

    const interactionComponent = createInteractionComponent<AccordionContent, AccordionState>(id, 'accordion', {
      title,
      instruction
    }, {
      items
    })
    interactionComponent.$mount();

    replaceWithElement(`#${id}`, interactionComponent.$el);

    return interactionComponent
  }

  private getItems($items: any): AccordionItem[] {
    let items: AccordionItem[] = [];
    $items.each((i: number, item: any) => {
      const $item = $(item);
      items = [...items, {
        label: $('.accordion__label', $item).html(),
        content: $('.accordion__content', $item).html()
      }];
    });

    return items;
  }
}
